export default __webpack_public_path__ + "static/media/vivid_vision_logo.a181ec32.png";